import React, { Component } from "react"
import axios from "axios"
import scroll from "react-scroll"
import store from "store"

import Page, { Grid, GridColumn } from "@atlaskit/page"
import Button from "@atlaskit/button"
import Avatar from "@atlaskit/avatar"
import Banner from "@atlaskit/banner"
import Modal from "@atlaskit/modal-dialog"

import SignOutIcon from "@atlaskit/icon/glyph/sign-out"
import WarningIcon from "@atlaskit/icon/glyph/warning"
import RefreshIcon from "@atlaskit/icon/glyph/refresh"

import Moment from "moment-timezone"
import "../../node_modules/moment/locale/de-at"

import Login from "./Login"
import ValidationList from "./ValidationList"
import TimeEntryList from "./TimeEntryList"
import Chart from "./Chart"
import ReportResult from "./ReportResult"
import DateSignature from "./DateSignature"
import Inputs from "./Inputs"

Moment.locale("de-at")
Moment.tz.setDefault("Europe/Vienna")

const refresh_icon = (
  <RefreshIcon label="Refresh icon" secondaryColor="inherit" />
)
const icon_sign_out = (
  <SignOutIcon label="Sign out icon" secondaryColor="inherit" />
)
const warning_icon = (
  <WarningIcon label="Warning icon" secondaryColor="inherit" />
)

function getParameterByName(name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[[]]/g, "\\$&")
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ""
  return decodeURIComponent(results[2].replace(/\+/g, " "))
}

function getEndpointByGuessing(path, protocol) {
  const hostname = window.location.hostname
  if (hostname.endsWith(".denovo.at")) {
    return `https://prd-toggl-validation-graphql.herokuapp.com/${path}`
  }
  if (hostname.includes("toggl-validation-portal")) {
    return `${protocol}://${hostname
      .split("-")
      .shift()}-toggl-validation-graphql.herokuapp.com/${path}`
  }
  if (hostname.endsWith(".herokuapp.com")) {
    return `${protocol}://${hostname
      .split("-")
      .shift()}-toggl-graphql.herokuapp.com/${path}`
  }
  return null
}

const VALIDATION_API_URL =
  getParameterByName("endpoint") ||
  getEndpointByGuessing("graphql/", "https") ||
  "http://localhost:4000/graphql/"

const BEARER = "bearer "

console.log(VALIDATION_API_URL)

var axiosTogglGraphQL = axios.create({
  baseURL: VALIDATION_API_URL
})

export const ERROR_SERVER_NOT_AVAILABLE = "Server ist zur Zeit nicht erreichbar"
export const ERROR_PREVIOUS_MONTH_NOT_SAVED =
  "Vormonat ist noch nicht abgeschlossen"
export const ERROR_EMAIL_EMPTY = "E-Mail muss eingetragen werden"
export const ERROR_PASSWORD_EMPTY = "Passwort muss eingetragen werden"
export const ERROR_WRONG_EMAIL_OR_PASSWORD =
  "E-Mail oder Passwort sind nicht korrekt"
export const ERROR_WEEKLY_TIME = "Bitte Wochenstunden korrekt eingeben"
export const ERROR_PREVIOUS_EXTRA_TIME =
  "Bitte Überstunden aus Vormonat korrekt eingeben"
export const ERROR_AVAILABLE_VACATION_DAYS =
  "Bitte verfügbare Urlaubstage korrekt eingeben"
export const ERROR_AVAILABLE_VACATION_DAYS_NEW =
  "Bitte neue Urlaubstage korrekt eingeben"
export const ERROR_AVAILABLE_VACATION_DAYS_NEW_CHANGED =
  "Gespeicherte Anzahl der neuen Urlaubstage entspricht nicht dem korrekten Wert ([value] Tage)"
export const ERROR_VACATION_DAYS = "Bitte genutzte Urlaubstage korrekt eingeben"
export const ERROR_VACATION_DAYS_CHANGED =
  "Gespeicherte Anzahl der Urlaubstage stimmt nicht mit der Anzahl vom Kalender ([value] Tage) überein"
export const ERROR_VACATION_DAYS_TOO_HIGH =
  "Mehr genutzte Urlaubstage als verfügbare Urlaubstage"
export const ERROR_HOLIDAY_DAYS = "Bitte Feiertage korrekt eingeben"
export const ERROR_HOLIDAY_DAYS_CHANGED =
  "Gespeicherte Anzahl der Feiertage stimmt nicht mit der Anzahl vom Kalender ([value] Tage) überein"
export const ERROR_PAID_EXTRA_TIME =
  "Bitte ausbezahlte Überstunden korrekt eingeben"
export const ERROR_INITIALS = "Bitte Initialien korrekt eingeben"
export const ERROR_BEGIN_DATE = "Bitte Datum korrekt eingeben"
export const ERROR_SPECIAL_VACATION_DAYS =
  "Bitte Sonderurlaubstage korrekt eingeben"
export const ERROR_SPECIAL_VACATION_DAYS_CHANGED =
  "Gespeicherte Anzahl der Sonderurlaubstage stimmt nicht mit der Anzahl vom Kalender ([value] Tage) überein"

export const ERROR_SICKENSS_DAYS =
    "Bitte Krankenstand korrekt eingeben"
export const ERROR_SICKENSS_DAYS_CHANGED =
    "Gespeicherte Anzahl der Krankheitstage stimmt nicht mit der Anzahl vom Kalender ([value] Tage) überein"

var extra_time_string = null
var weekly_work_time_duration_query = Moment.duration(38, "hours").add(
  30,
  "minutes"
)
var previous_extra_time_duration_query = Moment.duration(0, "hours")
var paid_extra_time_duration_query = Moment.duration(0, "hours")

var only_positive_duration_regex = new RegExp(
  "(?:([0-9]+)h){1}(?:([0-9]+)m)?|(?:([0-9]+)h)?(?:([0-9]+)m){1}"
)
var duration_regex = new RegExp(
  "-?(?:(?:([0-9]+)h){1}(?:([0-9]+)m)?|(?:([0-9]+)h)?(?:([0-9]+)m){1})"
)
var positive_numbers_only_regex = new RegExp("[0-9]+")

var expanded_days = null

const initial_state = {
  blocking_errors: [],
  nonblocking_errors: [],
  email: "",
  password: "",
  begin_date: "",
  api_token: null,
  is_logged_in: false,
  is_logging_in: false,
  is_loading: true,
  is_saving: false,
  pdf_url: null,
  show_pdf_dialog: false,
  print: false,
  fullname: null,
  image_url: null,
  from: Moment()
    .startOf("month")
    .format("YYYY-MM-DD"),
  to: Moment()
    .endOf("month")
    .format("YYYY-MM-DD"),
  month_selected: Moment().format("MMMM YYYY"),
  current_month_is_saved: false,
  validation_errors: {},
  total_validation_error_count: 0,
  work_time: 0,
  week_days_count: 0,
  vacation_days_count: "0",
  vacation_days_count_from_ical: "0",
  special_vacation_days_count: "0",
  special_vacation_days_count_from_ical: "0",
  sickness_days_count: "0",
  sickness_days_count_from_ical: "0",
  holiday_days_count: "0",
  holiday_days_count_from_ical: "0",
  weekly_work_time: "38h30m",
  previous_extra_time: "0h0m",
  available_vacation_days: "25",
  available_vacation_days_new: "0",
  available_vacation_days_new_correct: "0",
  paid_extra_time: "0h0m",
  initials: null,
  expanded_days_changed: false,
  homeOfficeDays: 0
}

class App extends Component {
  constructor(props) {
    super(props)
    //store.clearAll()
    var user_data = store.get("userData")

    if (user_data) {
      console.log("UserData exists")
      this.state = JSON.parse(user_data.state)
      this.state.show_pdf_dialog = false
      if (this.state.api_token != null) {
        axiosTogglGraphQL = axios.create({
          baseURL: VALIDATION_API_URL,
          headers: {
            Authorization: BEARER + this.state.api_token
          }
        })
      }
    } else {
      console.log("new state")
      this.state = initial_state
    }
  }

  render() {
    if (!this.state.is_loading) {
      store.set("userData", {
        state: JSON.stringify(this.state)
      })
    }

    const {
      blocking_errors,
      nonblocking_errors,
      email,
      password,
      begin_date,
      is_logged_in,
      is_logging_in,
      is_loading,
      is_saving,
      pdf_url,
      show_pdf_dialog,
      print,
      fullname,
      image_url,
      from,
      to,
      month_selected,
      current_month_is_saved,
      validation_errors,
      total_validation_error_count,
      work_time,
      week_days_count,
      vacation_days_count,
      vacation_days_count_from_ical,
      special_vacation_days_count,
      special_vacation_days_count_from_ical,
      sickness_days_count,
      sickness_days_count_from_ical,
      holiday_days_count,
      holiday_days_count_from_ical,
      weekly_work_time,
      previous_extra_time,
      available_vacation_days,
      available_vacation_days_new,
      available_vacation_days_new_correct,
      paid_extra_time,
      initials,
      homeOfficeDays
    } = this.state

    if (is_logged_in) {
      var fullname_object = (
        <div
          style={{
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            marginTop: "10px",
            fontSize: "20px",
            width: "270px",
            textAlign: "center"
          }}
        >
          <b>{fullname}</b>
        </div>
      )

      var work_time_duration = Moment.duration(work_time, "seconds")
      var weekly_work_time_duration = Moment.duration(0, "hours")
      var previous_extra_time_duration = Moment.duration(0, "hours")
      var paid_extra_time_duration = Moment.duration(0, "hours")
      var should_work_duration = Moment.duration(0, "seconds")
      var current_extra_time_duration = Moment.duration(0, "seconds")
      var total_extra_time_duration = Moment.duration(0, "seconds")

      var weekly_work_time_regex_result = weekly_work_time.match(
        only_positive_duration_regex
      )

      if (
        !blocking_errors.includes(ERROR_WEEKLY_TIME) &&
        !blocking_errors.includes(ERROR_VACATION_DAYS) &&
        !blocking_errors.includes(ERROR_HOLIDAY_DAYS) &&
        weekly_work_time_regex_result !== null
      ) {
        weekly_work_time_duration = Moment.duration(0, "hours")

        if (weekly_work_time_regex_result[1]) {
          weekly_work_time_duration = Moment.duration(
            parseInt(weekly_work_time_regex_result[1], 10),
            "hours"
          )
        } else if (weekly_work_time_regex_result[3]) {
          weekly_work_time_duration = Moment.duration(
            parseInt(weekly_work_time_regex_result[3], 10),
            "hours"
          )
        }
        if (weekly_work_time_regex_result[2]) {
          weekly_work_time_duration.add(
            parseInt(weekly_work_time_regex_result[2], 10),
            "minutes"
          )
        } else if (weekly_work_time_regex_result[4]) {
          weekly_work_time_duration.add(
            parseInt(weekly_work_time_regex_result[4], 10),
            "minutes"
          )
        }
        weekly_work_time_duration_query = weekly_work_time_duration

        var should_work_days =
          week_days_count -
          parseInt(vacation_days_count, 10) -
          parseInt(special_vacation_days_count, 10) -
          parseInt(sickness_days_count, 10) -
          parseInt(holiday_days_count, 10)

        should_work_duration = Moment.duration(
          should_work_days * (weekly_work_time_duration.asSeconds() / 5),
          "seconds"
        )

        current_extra_time_duration = Moment.duration(
          work_time_duration
        ).subtract(should_work_duration)

        var previous_extra_time_regex_result = previous_extra_time.match(
          only_positive_duration_regex
        )
        var paid_extra_time_regex_result = paid_extra_time.match(
          only_positive_duration_regex
        )
        if (
          !blocking_errors.includes(ERROR_PREVIOUS_EXTRA_TIME) &&
          !blocking_errors.includes(ERROR_PAID_EXTRA_TIME) &&
          previous_extra_time_regex_result !== null &&
          paid_extra_time_regex_result !== null
        ) {
          if (previous_extra_time_regex_result[1]) {
            previous_extra_time_duration = Moment.duration(
              parseInt(previous_extra_time_regex_result[1], 10),
              "hours"
            )
          } else if (previous_extra_time_regex_result[3]) {
            previous_extra_time_duration = Moment.duration(
              parseInt(previous_extra_time_regex_result[3], 10),
              "hours"
            )
          }
          if (previous_extra_time_regex_result[2]) {
            previous_extra_time_duration.add(
              parseInt(previous_extra_time_regex_result[2], 10),
              "minutes"
            )
          } else if (previous_extra_time_regex_result[4]) {
            previous_extra_time_duration.add(
              parseInt(previous_extra_time_regex_result[4], 10),
              "minutes"
            )
          }
          if (previous_extra_time.indexOf("-") !== -1) {
            previous_extra_time_duration = Moment.duration(
              -1 * previous_extra_time_duration.asSeconds(),
              "seconds"
            )
          }
          previous_extra_time_duration_query = previous_extra_time_duration

          if (paid_extra_time_regex_result[1]) {
            paid_extra_time_duration = Moment.duration(
              parseInt(paid_extra_time_regex_result[1], 10),
              "hours"
            )
          } else if (paid_extra_time_regex_result[3]) {
            paid_extra_time_duration = Moment.duration(
              parseInt(paid_extra_time_regex_result[3], 10),
              "hours"
            )
          }
          if (paid_extra_time_regex_result[2]) {
            paid_extra_time_duration.add(
              parseInt(paid_extra_time_regex_result[2], 10),
              "minutes"
            )
          } else if (paid_extra_time_regex_result[4]) {
            paid_extra_time_duration.add(
              parseInt(paid_extra_time_regex_result[4], 10),
              "minutes"
            )
          }
          paid_extra_time_duration_query = paid_extra_time_duration

          total_extra_time_duration = Moment.duration(
            current_extra_time_duration
          )
            .add(previous_extra_time_duration)
            .subtract(paid_extra_time_duration)

          extra_time_string = total_extra_time_duration.asSeconds()
        }
      }

      var color_extra_time = "green"
      if (current_extra_time_duration.format("h[h ]m[m]").includes("-")) {
        color_extra_time = "red"
      } else if (current_extra_time_duration.format("h[h ]m[m]") === "0m") {
        color_extra_time = "black"
      }

      var color_total_extra_time = "green"
      if (total_extra_time_duration.format("h[h ]m[m]").includes("-")) {
        color_total_extra_time = "red"
      } else if (total_extra_time_duration.format("h[h ]m[m]") === "0m") {
        color_total_extra_time = "black"
      }

      var error_message = null
      var warning_vacation_days_changed = null
      var warning_holiday_days_changed = null
      var warning_special_vacation_days_changed = null
      var warning_available_vacation_days_new_changed = null
      var warning_sickness_days_changed = null

      if (nonblocking_errors.includes(ERROR_SERVER_NOT_AVAILABLE)) {
        error_message = ERROR_SERVER_NOT_AVAILABLE
      } else if (nonblocking_errors.includes(ERROR_PREVIOUS_MONTH_NOT_SAVED)) {
        error_message = ERROR_PREVIOUS_MONTH_NOT_SAVED
      } else {
        if (nonblocking_errors.includes(ERROR_VACATION_DAYS_CHANGED)) {
          warning_vacation_days_changed = ERROR_VACATION_DAYS_CHANGED.replace(
            "[value]",
            vacation_days_count_from_ical
          )
        }
        if (nonblocking_errors.includes(ERROR_HOLIDAY_DAYS_CHANGED)) {
          warning_holiday_days_changed = ERROR_HOLIDAY_DAYS_CHANGED.replace(
            "[value]",
            holiday_days_count_from_ical
          )
        }

        if (nonblocking_errors.includes(ERROR_SPECIAL_VACATION_DAYS_CHANGED)) {
          warning_special_vacation_days_changed = ERROR_SPECIAL_VACATION_DAYS_CHANGED.replace(
            "[value]",
            special_vacation_days_count_from_ical
          )
        }

        if (nonblocking_errors.includes(ERROR_SICKENSS_DAYS_CHANGED)) {
            warning_special_vacation_days_changed = ERROR_SICKENSS_DAYS_CHANGED.replace(
                "[value]",
                sickness_days_count_from_ical
            )
        }

        if (
          nonblocking_errors.includes(ERROR_AVAILABLE_VACATION_DAYS_NEW_CHANGED)
        ) {
          warning_available_vacation_days_new_changed = ERROR_AVAILABLE_VACATION_DAYS_NEW_CHANGED.replace(
            "[value]",
            available_vacation_days_new_correct
          )
        }
      }

      var report_result_from = from
      if (
        Moment(report_result_from).format("YYYY-MM") ===
        Moment(begin_date, "D.M.YYYY").format("YYYY-MM")
      ) {
        report_result_from = Moment(begin_date, "D.M.YYYY").format("YYYY-MM-DD")
      }

      return (
        <div style={{ margin: "10px" }}>
          {show_pdf_dialog && (
            <Modal
              //actions={modal_dialog_actions}
              onClose={() => {
                this.setState({ show_pdf_dialog: false })
              }}
              onOpenComplete={this.generatePDFSign}
              heading="PDF Unterzeichnen"
            >
              <div id="pdfSignDiv" style={{ margin: "10px" }} />
            </Modal>
          )}
          <Page>
            <div style={{ borderBottom: "1px solid #d0d0d0" }}>
              <Grid>
                {!print ? (
                  <GridColumn medium={6}>
                    <img
                      src={require("../assets/denovo_logo.png")}
                      alt="Denovo"
                      height="40"
                      style={{}}
                    />
                  </GridColumn>
                ) : (
                  <GridColumn medium={4}>
                    <img
                      src={require("../assets/denovo_logo.png")}
                      alt="Denovo"
                      height="40"
                      style={{
                        width: "125px",
                        height: "auto",
                        marginTop: "8px"
                      }}
                    />
                  </GridColumn>
                )}

                <GridColumn medium={!print ? 4 : 4}>
                  {fullname_object}
                </GridColumn>
                {!print && (
                  <GridColumn medium={1}>
                    <div style={{ marginTop: "0px" }}>
                      <Avatar
                        src={image_url}
                        appearance="square"
                        size="large"
                      />
                    </div>
                  </GridColumn>
                )}
                {!print && (
                  <GridColumn medium={1}>
                    <div
                      style={{
                        marginTop: "4px",
                        textAlign: "right"
                      }}
                    >
                      <Button
                        className={
                          is_loading ? "buttonDisabled" : "buttonStandard"
                        }
                        id="logout_button"
                        appearance={is_loading ? "secondary" : "primary"}
                        isDisabled={is_loading ? true : false}
                        onClick={() => this.handleLogout()}
                        iconBefore={icon_sign_out}
                      />
                    </div>
                  </GridColumn>
                )}
                {print && (
                  <GridColumn medium={4}>
                    <div
                      style={{
                        fontSize: "20px",
                        marginTop: "10px",
                        textAlign: "right"
                      }}
                    >
                      {month_selected}
                    </div>
                  </GridColumn>
                )}
                {print && (
                  <GridColumn medium={6}>
                    <div
                      style={{
                        fontSize: "18px",
                        marginTop: "10px",
                        marginBottom: "20px",
                        textAlign: "left"
                      }}
                    >
                      {"Ist-Arbeitszeit: " +
                        work_time_duration.format("h[h ]m[m]")}
                    </div>
                  </GridColumn>
                )}
              </Grid>
            </div>

            {!print &&
              error_message && (
                <div
                  style={{
                    margin: "10px"
                  }}
                >
                  <Banner icon={warning_icon} isOpen={true} appearance="error">
                    {error_message}
                  </Banner>
                </div>
              )}
            {!print &&
              warning_vacation_days_changed && (
                <div
                  style={{
                    margin: "10px"
                  }}
                >
                  <Banner
                    icon={warning_icon}
                    isOpen={true}
                    appearance="warning"
                  >
                    {warning_vacation_days_changed}
                  </Banner>
                </div>
              )}
            {!print &&
              warning_holiday_days_changed && (
                <div
                  style={{
                    margin: "10px"
                  }}
                >
                  <Banner
                    icon={warning_icon}
                    isOpen={true}
                    appearance="warning"
                  >
                    {warning_holiday_days_changed}
                  </Banner>
                </div>
              )}
            {!print &&
              warning_special_vacation_days_changed && (
                <div
                  style={{
                    margin: "10px"
                  }}
                >
                  <Banner
                    icon={warning_icon}
                    isOpen={true}
                    appearance="warning"
                  >
                    {warning_special_vacation_days_changed}
                  </Banner>
                </div>
              )}
              {!print &&
              warning_sickness_days_changed && (
                  <div
                      style={{
                          margin: "10px"
                      }}
                  >
                      <Banner
                          icon={warning_icon}
                          isOpen={true}
                          appearance="warning"
                      >
                          {warning_sickness_days_changed}
                      </Banner>
                  </div>
              )}
            {!print &&
              warning_available_vacation_days_new_changed && (
                <div
                  style={{
                    margin: "10px"
                  }}
                >
                  <Banner
                    icon={warning_icon}
                    isOpen={true}
                    appearance="warning"
                  >
                    {warning_available_vacation_days_new_changed}
                  </Banner>
                </div>
              )}

            {!print && (
              <Inputs
                blocking_errors={blocking_errors}
                nonblocking_errors={nonblocking_errors}
                begin_date={begin_date}
                is_loading={is_loading}
                is_saving={is_saving}
                pdf_url={pdf_url}
                from={from}
                to={to}
                month_selected={month_selected}
                current_month_is_saved={current_month_is_saved}
                validation_errors={current_month_is_saved}
                total_validation_error_count={total_validation_error_count}
                vacation_days_count={vacation_days_count}
                special_vacation_days_count={special_vacation_days_count}
                sickness_days_count={sickness_days_count}
                holiday_days_count={holiday_days_count}
                weekly_work_time={weekly_work_time}
                previous_extra_time={previous_extra_time}
                available_vacation_days={available_vacation_days}
                available_vacation_days_new={available_vacation_days_new}
                paid_extra_time={paid_extra_time}
                initials={initials}
                updateFrom={this.updateFrom}
                updateTo={this.updateTo}
                updateBeginDate={this.updateBeginDate}
                updateInitials={this.updateInitials}
                updateWeeklyWorkTime={this.updateWeeklyWorkTime}
                updateAvailableVacationDays={this.updateAvailableVacationDays}
                updateAvailableVacationDaysNew={
                  this.updateAvailableVacationDaysNew
                }
                updateSpecialVacationDays={this.updateSpecialVacationDays}
                updateSicknessDays={this.updateSicknessDays}
                updateVacationDaysCount={this.updateVacationDaysCount}
                updateHolidayDaysCount={this.updateHolidayDaysCount}
                updatePreviousExtraTime={this.updatePreviousExtraTime}
                updatePaidExtraTime={this.updatePaidExtraTime}
                handleMonthBack={this.handleMonthBack}
                handleMonthForward={this.handleMonthForward}
                handleRefresh={this.handleRefresh}
                handlePrint={this.handlePrint}
                handleSaveMonth={this.handleSaveMonth}
                handleShowPDFSign={this.handleShowPDFSign}
                handleOpenPDF={this.handleOpenPDF}
                getValidationErrors={this.getValidationErrors}
                work_time_duration={work_time_duration}
                color_extra_time={color_extra_time}
                current_extra_time_duration={current_extra_time_duration}
                color_total_extra_time={color_total_extra_time}
                total_extra_time_duration={total_extra_time_duration}
                homeOfficeDays={homeOfficeDays}
              />
            )}

            <Grid>
              {!print &&
                work_time !== 0 && (
                  <Chart
                    validation_errors={validation_errors}
                    weekly_work_time_duration={weekly_work_time_duration}
                    handleErrorClick={this.handleErrorClick}
                  />
                )}
              {!print &&
                work_time === 0 && (
                  <h1 style={{ color: "#1bbbe9", marginTop: "40px" }}>
                    {"Keine Aufzeichnungen im ausgewählten Zeitraum"}
                  </h1>
                )}
              {!print &&
                total_validation_error_count !== 0 && (
                  <h1 style={{ color: "#1bbbe9" }}>
                    {"Insgesamt " +
                      total_validation_error_count +
                      " Fehler gefunden"}
                  </h1>
                )}

              {!print ? (
                <GridColumn>
                  <ValidationList
                    validation_errors={validation_errors}
                    expanded_days={expanded_days}
                    work_time_duration={work_time_duration}
                    current_extra_time_duration={current_extra_time_duration}
                    total_extra_time_duration={total_extra_time_duration}
                    is_loading={is_loading}
                    handleErrorClick={this.handleErrorClick}
                  />
                </GridColumn>
              ) : (
                <GridColumn>
                  <TimeEntryList validation_errors={validation_errors} />
                </GridColumn>
              )}
            </Grid>
            {!print && (
              <div
                style={{
                  marginTop: "40px",
                  textAlign: "right",
                  position: "fixed",
                  bottom: "10px",
                  right: "5%"
                }}
              >
                <Button
                  className="buttonStandard"
                  id="refresh_button"
                  appearance={"primary"}
                  iconBefore={refresh_icon}
                  onClick={() => this.handleRefresh()}
                />
              </div>
            )}
          </Page>
          {print && (
            <div
              style={{
                pageBreakBefore: "always",
                pageBreakInside: "avoid"
              }}
            >
              <ReportResult
                fullname={fullname}
                from={report_result_from}
                to={to}
                available_vacation_days={available_vacation_days}
                available_vacation_days_new={available_vacation_days_new}
                week_days_count={week_days_count}
                holiday_days_count={holiday_days_count}
                vacation_days_count={vacation_days_count}
                special_vacation_days_count={special_vacation_days_count}
                sickness_days_count={sickness_days_count}
                should_work_days={should_work_days}
                weekly_work_time_duration={weekly_work_time_duration}
                should_work_duration={should_work_duration}
                work_time_duration={work_time_duration}
                current_extra_time_duration={current_extra_time_duration}
                previous_extra_time_duration={previous_extra_time_duration}
                paid_extra_time_duration={paid_extra_time_duration}
                total_extra_time_duration={total_extra_time_duration}
                homeOfficeDays={homeOfficeDays}
              />
              <DateSignature />
              <div className="divFooter">
                {fullname + " / " + from + " - " + to}
              </div>
            </div>
          )}
        </div>
      )
    } else {
      return (
        <div style={{ margin: "10px" }}>
          <Page>
            <div style={{ borderBottom: "1px solid #d0d0d0" }}>
              <Grid>
                <GridColumn>
                  <img
                    src={require("../assets/denovo_logo.png")}
                    alt="Denovo"
                    height="40"
                    style={{}}
                  />
                </GridColumn>
              </Grid>
            </div>

            <Login
              email={email}
              password={password}
              is_logging_in={is_logging_in}
              updateEmail={this.updateEmail}
              updatePassword={this.updatePassword}
              handleLogin={this.handleLogin}
              blocking_errors={blocking_errors}
              nonblocking_errors={nonblocking_errors}
            />
          </Page>
        </div>
      )
    }
  }

  updateEmail = evt => {
    console.log("updateEmail")
    var new_errors = [...this.state.blocking_errors]
    if (
      evt.target.value === "" &&
      new_errors.indexOf(ERROR_EMAIL_EMPTY) === -1
    ) {
      new_errors.push(ERROR_EMAIL_EMPTY)
    } else if (new_errors.indexOf(ERROR_EMAIL_EMPTY) !== -1) {
      new_errors.splice(new_errors.indexOf(ERROR_EMAIL_EMPTY), 1)
    }
    this.setState({
      email: evt.target.value,
      blocking_errors: new_errors
    })
  }

  updatePassword = evt => {
    console.log("updatePassword")
    var new_errors = [...this.state.blocking_errors]
    if (
      evt.target.value === "" &&
      new_errors.indexOf(ERROR_PASSWORD_EMPTY) === -1
    ) {
      new_errors.push(ERROR_PASSWORD_EMPTY)
    } else if (new_errors.indexOf(ERROR_PASSWORD_EMPTY) !== -1) {
      new_errors.splice(new_errors.indexOf(ERROR_PASSWORD_EMPTY), 1)
    }
    this.setState({
      password: evt.target.value,
      blocking_errors: new_errors
    })
  }

  updateFrom = value => {
    console.log("updateFrom")
    var month = null
    if (
      (Moment(value).isSame(Moment(value).startOf("month"), "day") &&
        Moment(this.state.to).isSame(Moment(value).endOf("month"), "day")) ||
      (Moment(this.state.to).isSame(Moment(value).startOf("month"), "day") &&
        Moment(value).isSame(Moment(value).endOf("month"), "day"))
    ) {
      month = Moment(value).format("MMMM YYYY")
    }

    this.setState(
      {
        from: value,
        month_selected: month
      },
      () => {
        this.getValidationErrors(true)
      }
    )
  }

  updateTo = value => {
    console.log("updateTo")
    var month = null
    if (
      (Moment(this.state.from).isSame(
        Moment(this.state.from).startOf("month"),
        "day"
      ) &&
        Moment(value).isSame(Moment(this.state.from).endOf("month"), "day")) ||
      (Moment(value).isSame(Moment(this.state.from).startOf("month"), "day") &&
        Moment(this.state.from).isSame(
          Moment(this.state.from).endOf("month"),
          "day"
        ))
    ) {
      month = Moment(value).format("MMMM YYYY")
    }

    this.setState(
      {
        to: value,
        month_selected: month
      },
      () => {
        this.getValidationErrors(true)
      }
    )
  }

  updateWeeklyWorkTime = evt => {
    console.log("updateWeeklyWorkTime")
    var new_errors = [...this.state.blocking_errors]

    var input_is_valid =
      evt.target.value !== "" &&
      evt.target.value.replace(only_positive_duration_regex, "") === ""

    if (!input_is_valid && !new_errors.includes(ERROR_WEEKLY_TIME)) {
      new_errors.push(ERROR_WEEKLY_TIME)
    } else if (input_is_valid && new_errors.includes(ERROR_WEEKLY_TIME)) {
      new_errors.splice(new_errors.indexOf(ERROR_WEEKLY_TIME), 1)
    }

    this.setState({
      weekly_work_time: evt.target.value,
      blocking_errors: new_errors
    })
  }

  updateBeginDate = evt => {
    console.log("updateBeginDate")
    var new_errors = [...this.state.blocking_errors]
    var input_is_valid = Moment(evt.target.value, "D.M.YYYY", true).isValid()
    if (!input_is_valid && !new_errors.includes(ERROR_BEGIN_DATE)) {
      new_errors.push(ERROR_BEGIN_DATE)
    } else if (input_is_valid && new_errors.includes(ERROR_BEGIN_DATE)) {
      new_errors.splice(new_errors.indexOf(ERROR_BEGIN_DATE), 1)
    }

    this.setState({
      begin_date: evt.target.value,
      blocking_errors: new_errors
    })
  }

  updateAvailableVacationDays = evt => {
    console.log("updateAvailableVacationDays")
    var new_errors = [...this.state.blocking_errors]
    var input_is_valid =
      evt.target.value !== "" &&
      evt.target.value.replace(positive_numbers_only_regex, "") === ""

    if (
      !input_is_valid &&
      !new_errors.includes(ERROR_AVAILABLE_VACATION_DAYS)
    ) {
      new_errors.push(ERROR_AVAILABLE_VACATION_DAYS)
    } else if (
      input_is_valid &&
      new_errors.includes(ERROR_AVAILABLE_VACATION_DAYS)
    ) {
      new_errors.splice(new_errors.indexOf(ERROR_AVAILABLE_VACATION_DAYS), 1)
    }

    if (
      input_is_valid &&
      !new_errors.includes(ERROR_VACATION_DAYS) &&
      !new_errors.includes(ERROR_AVAILABLE_VACATION_DAYS_NEW) &&
      parseFloat(evt.target.value) +
        parseFloat(this.state.available_vacation_days_new) <
        parseFloat(this.state.vacation_days_count) &&
      !new_errors.includes(ERROR_VACATION_DAYS_TOO_HIGH)
    ) {
      new_errors.push(ERROR_VACATION_DAYS_TOO_HIGH)
    } else if (
      input_is_valid &&
      !new_errors.includes(ERROR_VACATION_DAYS) &&
      !new_errors.includes(ERROR_AVAILABLE_VACATION_DAYS_NEW) &&
      parseFloat(evt.target.value) +
        parseFloat(this.state.available_vacation_days_new) >=
        parseFloat(this.state.vacation_days_count) &&
      new_errors.includes(ERROR_VACATION_DAYS_TOO_HIGH)
    ) {
      new_errors.splice(new_errors.indexOf(ERROR_VACATION_DAYS_TOO_HIGH), 1)
    }
    this.setState({
      available_vacation_days: evt.target.value,
      blocking_errors: new_errors
    })
  }

  updateAvailableVacationDaysNew = evt => {
    console.log("updateAvailableVacationDaysNew")
    var new_errors = [...this.state.blocking_errors]
    var input_is_valid =
      evt.target.value !== "" &&
      evt.target.value.replace(positive_numbers_only_regex, "") === ""

    if (
      !input_is_valid &&
      !new_errors.includes(ERROR_AVAILABLE_VACATION_DAYS_NEW)
    ) {
      new_errors.push(ERROR_AVAILABLE_VACATION_DAYS_NEW)
    } else if (
      input_is_valid &&
      new_errors.includes(ERROR_AVAILABLE_VACATION_DAYS_NEW)
    ) {
      new_errors.splice(
        new_errors.indexOf(ERROR_AVAILABLE_VACATION_DAYS_NEW),
        1
      )
    }

    if (
      input_is_valid &&
      !new_errors.includes(ERROR_VACATION_DAYS) &&
      !new_errors.includes(ERROR_AVAILABLE_VACATION_DAYS) &&
      parseFloat(evt.target.value) +
        parseFloat(this.state.available_vacation_days) <
        parseFloat(this.state.vacation_days_count) &&
      !new_errors.includes(ERROR_VACATION_DAYS_TOO_HIGH)
    ) {
      new_errors.push(ERROR_VACATION_DAYS_TOO_HIGH)
    } else if (
      input_is_valid &&
      !new_errors.includes(ERROR_VACATION_DAYS) &&
      !new_errors.includes(ERROR_AVAILABLE_VACATION_DAYS) &&
      parseFloat(evt.target.value) +
        parseFloat(this.state.available_vacation_days) >=
        parseFloat(this.state.vacation_days_count) &&
      new_errors.includes(ERROR_VACATION_DAYS_TOO_HIGH)
    ) {
      new_errors.splice(new_errors.indexOf(ERROR_VACATION_DAYS_TOO_HIGH), 1)
    }
    this.setState({
      available_vacation_days_new: evt.target.value,
      blocking_errors: new_errors
    })
  }

  updateVacationDaysCount = evt => {
    console.log("updateVacationDaysCount")
    var new_errors = [...this.state.blocking_errors]
    var input_is_valid =
      evt.target.value !== "" &&
      evt.target.value.replace(positive_numbers_only_regex, "") === ""

    if (!input_is_valid && !new_errors.includes(ERROR_VACATION_DAYS)) {
      new_errors.push(ERROR_VACATION_DAYS)
    } else if (input_is_valid && new_errors.includes(ERROR_VACATION_DAYS)) {
      new_errors.splice(new_errors.indexOf(ERROR_VACATION_DAYS), 1)
    }

    if (
      input_is_valid &&
      !new_errors.includes(ERROR_AVAILABLE_VACATION_DAYS) &&
      !new_errors.includes(ERROR_AVAILABLE_VACATION_DAYS_NEW) &&
      parseFloat(evt.target.value) >
        parseFloat(this.state.available_vacation_days) +
          parseFloat(this.state.available_vacation_days_new) &&
      !new_errors.includes(ERROR_VACATION_DAYS_TOO_HIGH)
    ) {
      new_errors.push(ERROR_VACATION_DAYS_TOO_HIGH)
    } else if (
      input_is_valid &&
      !new_errors.includes(ERROR_AVAILABLE_VACATION_DAYS) &&
      !new_errors.includes(ERROR_AVAILABLE_VACATION_DAYS_NEW) &&
      parseFloat(evt.target.value) <=
        parseFloat(this.state.available_vacation_days) +
          parseFloat(this.state.available_vacation_days_new) &&
      new_errors.includes(ERROR_VACATION_DAYS_TOO_HIGH)
    ) {
      new_errors.splice(new_errors.indexOf(ERROR_VACATION_DAYS_TOO_HIGH), 1)
    }
    this.setState({
      vacation_days_count: evt.target.value,
      blocking_errors: new_errors
    })
  }

  updateSpecialVacationDays = evt => {
    console.log("updateSpecialVacationDays")
    var new_errors = [...this.state.blocking_errors]
    var input_is_valid =
      evt.target.value !== "" &&
      evt.target.value.replace(positive_numbers_only_regex, "") === ""

    if (!input_is_valid && !new_errors.includes(ERROR_SPECIAL_VACATION_DAYS)) {
      new_errors.push(ERROR_SPECIAL_VACATION_DAYS)
    } else if (
      input_is_valid &&
      new_errors.includes(ERROR_SPECIAL_VACATION_DAYS)
    ) {
      new_errors.splice(new_errors.indexOf(ERROR_SPECIAL_VACATION_DAYS), 1)
    }
    this.setState({
      special_vacation_days_count: evt.target.value,
      blocking_errors: new_errors
    })
  }

  updateSicknessDays = evt => {
    console.log("updateSicknessDays")
    var new_errors = [...this.state.blocking_errors]
    var input_is_valid =
        evt.target.value !== "" &&
        evt.target.value.replace(positive_numbers_only_regex, "") === ""

    if (!input_is_valid && !new_errors.includes(ERROR_SICKENSS_DAYS)) {
        new_errors.push(ERROR_SICKENSS_DAYS)
    } else if (
        input_is_valid &&
        new_errors.includes(ERROR_SICKENSS_DAYS)
    ) {
        new_errors.splice(new_errors.indexOf(ERROR_SICKENSS_DAYS), 1)
    }
    this.setState({
        sickness_days_count: evt.target.value,
        blocking_errors: new_errors
    })
}

  updateHolidayDaysCount = evt => {
    console.log("updateHolidayDaysCount")
    var new_errors = [...this.state.blocking_errors]
    var input_is_valid =
      evt.target.value !== "" &&
      evt.target.value.replace(positive_numbers_only_regex, "") === ""

    if (!input_is_valid && !new_errors.includes(ERROR_HOLIDAY_DAYS)) {
      new_errors.push(ERROR_HOLIDAY_DAYS)
    } else if (input_is_valid && new_errors.includes(ERROR_HOLIDAY_DAYS)) {
      new_errors.splice(new_errors.indexOf(ERROR_HOLIDAY_DAYS), 1)
    }
    this.setState({
      holiday_days_count: evt.target.value,
      blocking_errors: new_errors
    })
  }

  updatePreviousExtraTime = evt => {
    console.log("updatePreviousExtraTime")
    var new_errors = [...this.state.blocking_errors]

    var input_is_valid =
      evt.target.value !== "" &&
      evt.target.value.replace(duration_regex, "") === ""

    if (!input_is_valid && !new_errors.includes(ERROR_PREVIOUS_EXTRA_TIME)) {
      new_errors.push(ERROR_PREVIOUS_EXTRA_TIME)
    } else if (
      input_is_valid &&
      new_errors.includes(ERROR_PREVIOUS_EXTRA_TIME)
    ) {
      new_errors.splice(new_errors.indexOf(ERROR_PREVIOUS_EXTRA_TIME), 1)
    }

    this.setState({
      previous_extra_time: evt.target.value,
      blocking_errors: new_errors
    })
  }

  updatePaidExtraTime = evt => {
    console.log("updatePaidExtraTime")
    var new_errors = [...this.state.blocking_errors]

    var input_is_valid =
      evt.target.value !== "" &&
      evt.target.value.replace(only_positive_duration_regex, "") === ""

    if (!input_is_valid && !new_errors.includes(ERROR_PAID_EXTRA_TIME)) {
      new_errors.push(ERROR_PAID_EXTRA_TIME)
    } else if (input_is_valid && new_errors.includes(ERROR_PAID_EXTRA_TIME)) {
      new_errors.splice(new_errors.indexOf(ERROR_PAID_EXTRA_TIME), 1)
    }

    this.setState({
      paid_extra_time: evt.target.value,
      blocking_errors: new_errors
    })
  }

  updateInitials = evt => {
    console.log("updateInitials")
    var new_errors = [...this.state.blocking_errors]

    var input_is_valid = evt.target.value !== ""

    if (!input_is_valid && !new_errors.includes(ERROR_INITIALS)) {
      new_errors.push(ERROR_INITIALS)
    } else if (input_is_valid && new_errors.includes(ERROR_INITIALS)) {
      new_errors.splice(new_errors.indexOf(ERROR_INITIALS), 1)
    }
    this.setState({
      initials: evt.target.value,
      blocking_errors: new_errors
    })
  }

  handleErrorClick = (value, boolean_scroll = false) => {
    console.log("handleErrorClick")
    console.log(value)

    if (!expanded_days) {
      expanded_days = new Map()
    }
    if (boolean_scroll === true) {
      expanded_days.set(value, true)
      scroll.scroller.scrollTo(value, {
        duration: 1300,
        smooth: "easeInOutQuint",
        offset: -5
      })
    } else {
      if (expanded_days.get(value) === true) {
        expanded_days.delete(value)
      } else {
        expanded_days.set(value, true)
      }
    }
    this.setState({
      expanded_days_changed: true
    })
  }

  handleRefresh = (reload_fields = false) => {
    console.log("handleRefresh")
    this.getValidationErrors(reload_fields)
  }

  handlePrint = () => {
    console.log("handlePrint")
    this.setState(
      {
        print: true,
        from: Moment(this.state.from).isAfter(Moment(this.state.to))
          ? this.state.to
          : this.state.from,
        to: Moment(this.state.from).isAfter(Moment(this.state.to))
          ? this.state.from
          : this.state.to
      },
      () => {
        window.print()
        this.setState({
          print: false
        })
      }
    )
  }

  handleMonthBack = () => {
    console.log("handleMonthBack")
    var new_from = Moment(this.state.from).startOf("month")

    if (
      Moment(this.state.from).isSame(
        Moment(this.state.from).startOf("month"),
        "day"
      )
    ) {
      new_from = new_from.subtract(1, "month").startOf("month")
    }

    var new_to = Moment(new_from).endOf("month")
    this.setState(
      {
        from: new_from.format("YYYY-MM-DD"),
        to: new_to.format("YYYY-MM-DD"),
        month_selected: new_from.format("MMMM YYYY")
      },
      () => {
        if (this.state.blocking_errors.length === 0) {
          this.getValidationErrors(true)
        }
      }
    )
  }

  handleMonthForward = () => {
    console.log("handleMonthForward")
    var new_to = Moment(this.state.to).endOf("month")

    if (
      Moment(this.state.to).isSame(Moment(this.state.to).endOf("month"), "day")
    ) {
      new_to = new_to.add(1, "month").endOf("month")
    }

    var new_from = Moment(new_to).startOf("month")
    this.setState(
      {
        from: new_from.format("YYYY-MM-DD"),
        to: new_to.format("YYYY-MM-DD"),
        month_selected: new_from.format("MMMM YYYY")
      },
      () => {
        if (this.state.blocking_errors.length === 0) {
          this.getValidationErrors(true)
        }
      }
    )
  }

  handleSaveMonth = () => {
    console.log("handleSaveMonth")
    this.save()
  }

  handleOpenPDF = () => {
    console.log("handleOpenPDF")
    window.open(this.state.pdf_url)
  }

  handleShowPDFSign = () => {
    console.log("handleShowPDFSign")
    this.setState({
      show_pdf_dialog: true
    })
  }

  handleLogin = () => {
    console.log("handleLogin")
    this.setState(
      {
        is_logging_in: true
      },
      () => {
        this.authenticate()
      }
    )
  }

  handleLogout = () => {
    console.log("handleLogout")
    this.setState(initial_state)
    axiosTogglGraphQL = axios.create({
      baseURL: VALIDATION_API_URL
    })
    store.clearAll()
  }

  generatePDFSign = async () => {
    var my_pdfAs = null
    var op = {
      //content: "http://www.example.com/test.pdf", // Diese Eigenschaft ist optional, wenn ausgelassen wird dem Benutzer ein File Upload angezeigt. Dies ist eine URL zum PDF Dokument welches signiert werden soll.
      //connector: "mobilebku", // Diese Eigenschaft ist optional, wenn ausgelassen wird dem Benutzer gefragt. Moegliche Werte sind: "bku" -> Signatur mit der lokalen BKU, "onlinebku" -> Signatur mit der online BKU, "mobilebku" -> Signatur mit der Handy Signatur
      uiId: "pdfSignDiv", // Diese Eigenschaft ist optional, wenn ausgelassen wird ein Overlay erzeugt. Dies ist die id eines div elements in das das iframe zur Benutzerinteraktion eingefuegt werden soll.
      sig_pos_x: 100, // Die X-Koordinate der links-unten Signaturblockecke.
      sig_pos_y: 100, // Die X-Koordinate der links-unten Signaturblockecke.
      sig_pos_p: 100, // Die Seite auf der der Signaturblock platziert werden soll. // or last page if bigger than amount of pages
      sig_pos_w: 300, //Die Breite des Signaturblocks
      sig_pos_f: 40 // Die Hoehe der Fuszzeile ueber der der Signaturblock platziert werden soll.
    }

    // eslint-disable-next-line no-undef
    my_pdfAs = pdfAs

    console.log("sign pdf")
    var pdf_url = await new Promise((resolve, reject) => {
      my_pdfAs.signPdf(
        op,
        function(error, cause) {
          resolve(null)
        },
        function(pdfurl) {
          resolve(pdfurl)
        }
      )
    })
    if (pdf_url) {
      this.setState({
        pdf_url: pdf_url,
        show_pdf_dialog: false
      })
    } else {
      this.setState({
        show_pdf_dialog: false
      })
    }
  }

  authenticate = async () => {
    console.log("authenticate")
    var query = getAuthenticationMutation(this.state.email, this.state.password)
    var new_nonblocking_errors = null
    try {
      axiosTogglGraphQL.post("", { query: query }).then(
        result => {
          if (result.data.errors && result.data.errors[0]) {
            new_nonblocking_errors = [...this.state.nonblocking_errors]
            if (
              !new_nonblocking_errors.includes(ERROR_WRONG_EMAIL_OR_PASSWORD)
            ) {
              new_nonblocking_errors.push(ERROR_WRONG_EMAIL_OR_PASSWORD)
            }
            this.setState({
              nonblocking_errors: new_nonblocking_errors,
              is_logging_in: false
            })
            return
          }
          axiosTogglGraphQL = axios.create({
            baseURL: VALIDATION_API_URL,
            headers: {
              Authorization: BEARER + result.data.data.authenticate.token
            }
          })

          var new_weekly_work_time = this.state.weekly_work_time
          new_weekly_work_time = Moment.duration(
            result.data.data.authenticate.weeklyWorkTime,
            "seconds"
          ).format("h[h]m[m]")

          this.setState(
            {
              is_logged_in: true,
              password: "",
              api_token: result.data.data.authenticate.token,
              fullname: result.data.data.authenticate.name,
              initials: result.data.data.authenticate.name,
              weekly_work_time: new_weekly_work_time,
              begin_date: Moment(
                result.data.data.authenticate.beginDate,
                "YYYY-MM-DD"
              ).format("D.M.YYYY"),
              image_url: result.data.data.authenticate.imageUrl,
              is_logging_in: false,
              blocking_errors: [],
              nonblocking_errors: []
            },
            () => {
              this.getValidationErrors(true)
            }
          )
        },
        error => {
          new_nonblocking_errors = [...this.state.nonblocking_errors]
          if (!new_nonblocking_errors.includes(ERROR_SERVER_NOT_AVAILABLE)) {
            new_nonblocking_errors.push(ERROR_SERVER_NOT_AVAILABLE)
          }
          this.setState(() => ({
            nonblocking_errors: new_nonblocking_errors,
            is_logging_in: false
          }))
        }
      )
    } catch (error) {
      new_nonblocking_errors = [...this.state.nonblocking_errors]
      if (!new_nonblocking_errors.includes(ERROR_SERVER_NOT_AVAILABLE)) {
        new_nonblocking_errors.push(ERROR_SERVER_NOT_AVAILABLE)
      }
      this.setState(() => ({
        nonblocking_errors: new_nonblocking_errors,
        is_logging_in: false
      }))
    }
  }

  save = async () => {
    console.log("save")
    this.setState({
      is_saving: true
    })
    var query = getSaveMutation(
      this.state.email,
      Moment(this.state.from).format("YYYY-MM"),
      this.state.initials,
      Moment(this.state.begin_date, "D.M.YYYY").format("YYYY-MM-DD"),
      extra_time_string,
      weekly_work_time_duration_query.asSeconds(),
      this.state.available_vacation_days,
      this.state.available_vacation_days_new,
      this.state.vacation_days_count,
      this.state.special_vacation_days_count,
      this.state.sickness_days_count,
      this.state.holiday_days_count,
      previous_extra_time_duration_query.asSeconds(),
      paid_extra_time_duration_query.asSeconds()
    )
    var new_errors = null
    try {
      axiosTogglGraphQL.post("", { query: query }).then(
        result => {
          new_errors = [...this.state.nonblocking_errors]
          if (result.data.errors && result.data.errors[0]) {
            if (!new_errors.includes(ERROR_PREVIOUS_MONTH_NOT_SAVED)) {
              new_errors.push(ERROR_PREVIOUS_MONTH_NOT_SAVED)
            }
            this.setState({
              nonblocking_errors: new_errors,
              is_saving: false
            })
            return
          }

          if (new_errors.includes(ERROR_VACATION_DAYS_CHANGED)) {
            new_errors.splice(
              new_errors.indexOf(ERROR_VACATION_DAYS_CHANGED),
              1
            )
          }

          if (new_errors.includes(ERROR_HOLIDAY_DAYS_CHANGED)) {
            new_errors.splice(new_errors.indexOf(ERROR_HOLIDAY_DAYS_CHANGED), 1)
          }

          if (new_errors.includes(ERROR_SPECIAL_VACATION_DAYS_CHANGED)) {
            new_errors.splice(
              new_errors.indexOf(ERROR_SPECIAL_VACATION_DAYS_CHANGED),
              1
            )
          }

          if (new_errors.includes(ERROR_SICKENSS_DAYS_CHANGED)) {
              new_errors.splice(
                  new_errors.indexOf(ERROR_SICKENSS_DAYS_CHANGED),
                  1
              )
          }

          if (new_errors.includes(ERROR_AVAILABLE_VACATION_DAYS_NEW_CHANGED)) {
            new_errors.splice(
              new_errors.indexOf(ERROR_AVAILABLE_VACATION_DAYS_NEW_CHANGED),
              1
            )
          }

          this.setState({
            is_saving: false,
            current_month_is_saved: true,
            nonblocking_errors: new_errors
          })
        },
        error => {
          new_errors = [...this.state.nonblocking_errors]
          if (!new_errors.includes(ERROR_SERVER_NOT_AVAILABLE)) {
            new_errors.push(ERROR_SERVER_NOT_AVAILABLE)
          }
          this.setState(() => ({
            nonblocking_errors: new_errors,
            is_saving: false
          }))
        }
      )
    } catch (error) {
      new_errors = [...this.state.nonblocking_errors]
      if (!new_errors.includes(ERROR_SERVER_NOT_AVAILABLE)) {
        new_errors.push(ERROR_SERVER_NOT_AVAILABLE)
      }
      this.setState(() => ({
        nonblocking_errors: new_errors,
        is_saving: false
      }))
    }
  }

  getValidationErrors = async (reload_fields = false) => {
    console.log("getValidationErrors")
    var new_blocking_errors = null
    var new_nonblocking_errors = null

    if (this.state.blocking_errors.length !== 0) {
      return
    }

    var month_selected = this.state.month_selected !== null ? "true" : "false"
    var query = getValidationQuery(
      this.state.from,
      this.state.to,
      month_selected,
      weekly_work_time_duration_query.asHours(),
      this.state.initials,
      Moment(this.state.begin_date, "D.M.YYYY").format("YYYY-MM-DD")
    )
    if (reload_fields === true) {
      expanded_days = null
    }
    this.setState({
      is_loading: true
    })

    try {
      axiosTogglGraphQL.post("", { query: query }).then(
        result => {
          if (result.data.errors && result.data.errors[0]) {
            new_nonblocking_errors = []
            new_nonblocking_errors.push(result.data.errors[0].message)
            this.setState({
              nonblocking_errors: new_nonblocking_errors,
              is_loading: false
            })
            this.handleLogout()
            return
          }
          if (!this.state.is_logged_in) {
            return
          }

          var total_errors = 0
          for (
            var counter = 0;
            counter < result.data.data.validation.days.length;
            counter++
          ) {
            total_errors +=
              result.data.data.validation.days[counter].errors.length
          }

          new_blocking_errors = [...this.state.blocking_errors]
          new_nonblocking_errors = [...this.state.nonblocking_errors]
          if (new_nonblocking_errors.includes(ERROR_SERVER_NOT_AVAILABLE)) {
            new_nonblocking_errors.splice(
              new_nonblocking_errors.indexOf(ERROR_SERVER_NOT_AVAILABLE),
              1
            )
          }
          if (new_nonblocking_errors.includes(ERROR_PREVIOUS_MONTH_NOT_SAVED)) {
            new_nonblocking_errors.splice(
              new_nonblocking_errors.indexOf(ERROR_PREVIOUS_MONTH_NOT_SAVED),
              1
            )
          }
          if (
            new_nonblocking_errors.includes(
              ERROR_AVAILABLE_VACATION_DAYS_NEW_CHANGED
            )
          ) {
            new_nonblocking_errors.splice(
              new_nonblocking_errors.indexOf(
                ERROR_AVAILABLE_VACATION_DAYS_NEW_CHANGED
              ),
              1
            )
          }
          if (new_nonblocking_errors.includes(ERROR_VACATION_DAYS_CHANGED)) {
            new_nonblocking_errors.splice(
              new_nonblocking_errors.indexOf(ERROR_VACATION_DAYS_CHANGED),
              1
            )
          }
          if (new_nonblocking_errors.includes(ERROR_HOLIDAY_DAYS_CHANGED)) {
            new_nonblocking_errors.splice(
              new_nonblocking_errors.indexOf(ERROR_HOLIDAY_DAYS_CHANGED),
              1
            )
          }
          if (
            new_nonblocking_errors.includes(ERROR_SPECIAL_VACATION_DAYS_CHANGED)
          ) {
            new_nonblocking_errors.splice(
              new_nonblocking_errors.indexOf(
                ERROR_SPECIAL_VACATION_DAYS_CHANGED
              ),
              1
            )
          }
          if (
            new_nonblocking_errors.includes(ERROR_SICKENSS_DAYS_CHANGED)
          ) {
            new_nonblocking_errors.splice(
                new_nonblocking_errors.indexOf(
                    ERROR_SICKENSS_DAYS_CHANGED
                ),
                1
            )
           }

          var new_previous_extra_time = this.state.previous_extra_time
          var new_paid_extra_time = this.state.paid_extra_time
          var new_available_vacation_days_count = this.state
            .available_vacation_days
          var new_available_vacation_days_count_new = this.state
            .available_vacation_days_new
          var new_available_vacation_days_count_new_correct = this.state
            .available_vacation_days_new_correct
          var new_vacation_days_count = this.state.vacation_days_count
          var new_vacation_days_count_from_ical = this.state
            .vacation_days_count_from_ical
          var new_holiday_days_count = this.state.holiday_days_count
          var new_holiday_days_count_from_ical = this.state
            .holiday_days_count_from_ical
          var new_special_vacation_days_count = this.state
            .special_vacation_days_count
          var new_special_vacation_days_count_from_ical = this.state
            .special_vacation_days_count_from_ical
          var new_sickness_days_count = this.state
            .sickness_days_count
          var new_sickness_days_count_from_ical = this.state
            .sickness_days_count_from_ical
          let homeOfficeDays = this.state.homeOfficeDays


          if (reload_fields) {
            if (new_blocking_errors.includes(ERROR_HOLIDAY_DAYS)) {
              new_blocking_errors.splice(
                new_blocking_errors.indexOf(ERROR_HOLIDAY_DAYS),
                1
              )
            }
            if (new_blocking_errors.includes(ERROR_AVAILABLE_VACATION_DAYS)) {
              new_blocking_errors.splice(
                new_blocking_errors.indexOf(ERROR_AVAILABLE_VACATION_DAYS),
                1
              )
            }
            if (
              new_blocking_errors.includes(ERROR_AVAILABLE_VACATION_DAYS_NEW)
            ) {
              new_blocking_errors.splice(
                new_blocking_errors.indexOf(ERROR_AVAILABLE_VACATION_DAYS_NEW),
                1
              )
            }
            if (new_blocking_errors.includes(ERROR_SPECIAL_VACATION_DAYS)) {
              new_blocking_errors.splice(
                new_blocking_errors.indexOf(ERROR_SPECIAL_VACATION_DAYS),
                1
              )
            }

            if (new_blocking_errors.includes(ERROR_SICKENSS_DAYS)) {
               new_blocking_errors.splice(
                  new_blocking_errors.indexOf(ERROR_SICKENSS_DAYS),
                  1
               )
            }

            if (new_blocking_errors.includes(ERROR_VACATION_DAYS)) {
              new_blocking_errors.splice(
                new_blocking_errors.indexOf(ERROR_VACATION_DAYS),
                1
              )
            }
            if (new_blocking_errors.includes(ERROR_PREVIOUS_EXTRA_TIME)) {
              new_blocking_errors.splice(
                new_blocking_errors.indexOf(ERROR_PREVIOUS_EXTRA_TIME),
                1
              )
            }
            if (new_blocking_errors.includes(ERROR_PAID_EXTRA_TIME)) {
              new_blocking_errors.splice(
                new_blocking_errors.indexOf(ERROR_PAID_EXTRA_TIME),
                1
              )
            }
            if (new_blocking_errors.includes(ERROR_VACATION_DAYS_TOO_HIGH)) {
              new_blocking_errors.splice(
                new_blocking_errors.indexOf(ERROR_VACATION_DAYS_TOO_HIGH),
                1
              )
            }
            if (
              result.data.data.validation.availableVacationDaysCount +
                result.data.data.validation.availableVacationDaysCountNew <
              result.data.data.validation.vacationDaysCount
            ) {
              new_blocking_errors.push(ERROR_VACATION_DAYS_TOO_HIGH)
            }

            new_previous_extra_time = Moment.duration(
              result.data.data.validation.previousExtraTime,
              "seconds"
            ).format("h[h]m[m]")
            new_paid_extra_time = Moment.duration(
              result.data.data.validation.paidExtraTime,
              "seconds"
            ).format("h[h]m[m]")
            new_available_vacation_days_count = result.data.data.validation.availableVacationDaysCount.toString()
            new_available_vacation_days_count_new = result.data.data.validation.availableVacationDaysCountNew.toString()
            new_available_vacation_days_count_new_correct = result.data.data.validation.availableVacationDaysCountNewCorrect.toString()
            new_vacation_days_count = result.data.data.validation.vacationDaysCount.toString()
            new_vacation_days_count_from_ical = result.data.data.validation.vacationDaysCountFromIcal.toString()
            new_special_vacation_days_count = result.data.data.validation.specialVacationDaysCount.toString()
            new_special_vacation_days_count_from_ical = result.data.data.validation.specialVacationDaysCountFromIcal.toString()
            new_holiday_days_count = result.data.data.validation.holidayDaysCount.toString()
            new_holiday_days_count_from_ical = result.data.data.validation.holidayDaysCountFromIcal.toString()
            new_sickness_days_count = result.data.data.validation.sicknessDaysCount.toString()
            new_sickness_days_count_from_ical = result.data.data.validation.sicknessDaysCountFromIcal.toString()
            homeOfficeDays = result.data.data.validation.homeOfficeDaysCount

            if (
              result.data.data.validation.vacationDaysCount !==
                result.data.data.validation.vacationDaysCountFromIcal &&
              !new_nonblocking_errors.includes(ERROR_VACATION_DAYS_CHANGED)
            ) {
              new_nonblocking_errors.push(ERROR_VACATION_DAYS_CHANGED)
            }

            if (
              result.data.data.validation.specialVacationDaysCount !==
                result.data.data.validation.specialVacationDaysCountFromIcal &&
              !new_nonblocking_errors.includes(
                ERROR_SPECIAL_VACATION_DAYS_CHANGED
              )
            ) {
              new_nonblocking_errors.push(ERROR_SPECIAL_VACATION_DAYS_CHANGED)
            }


              if (
                  result.data.data.validation.sicknessDaysCount !==
                  result.data.data.validation.sicknessDaysCountFromIcal &&
                  !new_nonblocking_errors.includes(
                      ERROR_SICKENSS_DAYS_CHANGED
                  )
              ) {
                  new_nonblocking_errors.push(ERROR_SICKENSS_DAYS_CHANGED)
              }



            if (
              result.data.data.validation.holidayDaysCount !==
                result.data.data.validation.holidayDaysCountFromIcal &&
              !new_nonblocking_errors.includes(ERROR_HOLIDAY_DAYS_CHANGED)
            ) {
              new_nonblocking_errors.push(ERROR_HOLIDAY_DAYS_CHANGED)
            }

            if (
              result.data.data.validation.availableVacationDaysCountNew !==
                result.data.data.validation
                  .availableVacationDaysCountNewCorrect &&
              !new_nonblocking_errors.includes(
                ERROR_AVAILABLE_VACATION_DAYS_NEW_CHANGED
              )
            ) {
              new_nonblocking_errors.push(
                ERROR_AVAILABLE_VACATION_DAYS_NEW_CHANGED
              )
            }
          }

          this.setState({
            validation_errors: result.data.data.validation,
            total_validation_error_count: total_errors,
            work_time: result.data.data.validation.totalWorkTime,
            previous_extra_time: new_previous_extra_time,
            paid_extra_time: new_paid_extra_time,
            available_vacation_days: new_available_vacation_days_count,
            available_vacation_days_new: new_available_vacation_days_count_new,
            available_vacation_days_new_correct: new_available_vacation_days_count_new_correct,
            week_days_count: result.data.data.validation.weekDaysCount,
            vacation_days_count: new_vacation_days_count,
            vacation_days_count_from_ical: new_vacation_days_count_from_ical,
            special_vacation_days_count: new_special_vacation_days_count,
            special_vacation_days_count_from_ical: new_special_vacation_days_count_from_ical,
            sickness_days_count: new_sickness_days_count,
            sickness_days_count_from_ical: new_sickness_days_count_from_ical,
            holiday_days_count: new_holiday_days_count,
            holiday_days_count_from_ical: new_holiday_days_count_from_ical,
            current_month_is_saved: result.data.data.validation.currentMonthIsSaved,
            blocking_errors: new_blocking_errors,
            nonblocking_errors: new_nonblocking_errors,
            is_loading: false,
            homeOfficeDays,
          })
        },
        error => {
          new_nonblocking_errors = [...this.state.nonblocking_errors]
          if (!new_nonblocking_errors.includes(ERROR_SERVER_NOT_AVAILABLE)) {
            new_nonblocking_errors.push(ERROR_SERVER_NOT_AVAILABLE)
          }
          this.setState(() => ({
            nonblocking_errors: new_nonblocking_errors,
            is_loading: false
          }))
        }
      )
    } catch (error) {
      new_nonblocking_errors = [...this.state.nonblocking_errors]
      if (!new_nonblocking_errors.includes(ERROR_SERVER_NOT_AVAILABLE)) {
        new_nonblocking_errors.push(ERROR_SERVER_NOT_AVAILABLE)
      }
      this.setState(() => ({
        nonblocking_errors: new_nonblocking_errors,
        is_loading: false
      }))
    }
  }
}

function getValidationQuery(
  from,
  to,
  month_selected,
  weekly_work_time,
  initials,
  begin_date
) {
  return `query {
    validation(from: "${from}", to: "${to}", month_selected:${month_selected}, initials: "${initials}", begin_date: "${begin_date}", weekly_work_time:${weekly_work_time}) {
      start
      stop
      totalWorkTime
      previousExtraTime
      paidExtraTime
      availableVacationDaysCount
      availableVacationDaysCountNew
      availableVacationDaysCountNewCorrect
      weekDaysCount
      vacationDaysCount
      vacationDaysCountFromIcal
      specialVacationDaysCount
      specialVacationDaysCountFromIcal
      sicknessDaysCount
      sicknessDaysCountFromIcal
      holidayDaysCount
      holidayDaysCountFromIcal
      homeOfficeDaysCount
      currentMonthIsSaved
      days {
        date
        description
        workTime
        extraTime
        timeEntries {
          start
          stop
          duration
          breakAfterEntry
        }
        errors {
          code
          entry_project
          entry_description
          time
          message
        }
      }
    }
  }
  `
}

function getAuthenticationMutation(email, password) {
  return `
  mutation
  {
    authenticate(username: "${email}", password: "${password}"){
      token
      name
      imageUrl
      initials
      weeklyWorkTime
      beginDate
    }
  }
  `
}

function getSaveMutation(
  email,
  month,
  initials,
  begin_date,
  extra_time,
  weekly_work_time,
  available_vacation_days,
  available_vacation_days_new,
  vacation_days,
  special_vacation_days,
  sickness_days,
  holiday_days,
  previous_extra_time,
  paid_extra_time
) {
  return `
  mutation
  {
    saveInDatabase(email: "${email}", 
      month: "${month}", 
      initials: "${initials}", 
      begin_date: "${begin_date}", 
      extra_time: ${extra_time}, 
      weekly_work_time: ${weekly_work_time}, 
      available_vacation_days: ${available_vacation_days}, 
      available_vacation_days_new: ${available_vacation_days_new}, 
      vacation_days: ${vacation_days}, 
      special_vacation_days: ${special_vacation_days}, 
      sickness_days: ${sickness_days}
      holiday_days: ${holiday_days}, 
      previous_extra_time: ${previous_extra_time}, 
      paid_extra_time: ${paid_extra_time}) {
      error
    }
  }
  `
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.jsx